export class EzPayAdapter {
    constructor() {
        this.processingMessage = "Payment Process Underway – Waiting for payment confirmation from EzPay";
    }
    init(data, driver) {
        // the EzPay adapter never resolves, instead it calls directly to the driver when done.
        // this is because the submission of the project is done by the processing of the
        // EzPay callback and we dont want to
        // submit the project again.
        this.promise = new Promise((_resolve, _reject) => {
            this.resolve = _resolve; // capture internal _resolve into resolve
            this.reject = _reject; // same, but for _reject/reject
        });
        if (data) {
            this._ezPayUrl = data.EzPayUrl;
        }
        this._childWindow = null;
        this._driver = driver;
    }

    checkout() {
        this._childWindow = window.open(this._ezPayUrl, "_blank");
        this._driver.$app.unBlockUi();
        this.delayedSubmit();
        return this.promise;
    }
    delayedSubmit(driver) {
        if (driver) {
            this._driver = driver;
        }
        setTimeout(this._checkChargeStatus.bind(this), 2000);
    }
    cancelDelayedSubmit() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    }
    async _checkChargeStatus() {
        //ignore if chargeId is null since the check will fail anyway
        if (!this._driver.chargeId) {
            return;
        }
        const result = await this._driver.EzPayCheckChargeStatus();

        if (result.Data.MessageProcessed) {
            //this._childWindow.close(); TODO? need to check with SMUD on desired workflow
            this._driver.$app.setUnsavedChanges(false);
            this._driver.showDialogAndNavigateToNext(result.Data.ReceiptInfo, result.Data.NavigateUrl);
        } else {
            // we have an initial wait of 2 secs, and then we check the status every 1 sec.
            // The initial wait is longer since it takes time to fill out the EzPay page.
            // No need to make this poll too fast. It usually doesn't make a huge difference,
            // but in cases with lots of traffic in programs using these adapters the number of
            // requests can jump up real fast
            this.timeout = setTimeout(this._checkChargeStatus.bind(this), 1000);
        }
    }
}
